import BentoItem, { ImageItem } from './BentoItem';

interface BentoGridProps {
  images: ImageItem[]
  openLightbox: (index: number) => void
}

export const BentoGrid = ({ images, openLightbox }: BentoGridProps) => {
  return (
    <div className="grid grid-cols-12 gap-4 auto-rows-[200px]">
      {images.map((image, index) => {
        const patternIndex = index % 5

        // 2 velike
        if (patternIndex === 0) {
          return (
            <BentoItem
              key={index}
              image={image}
              onClick={() => openLightbox(index)}
              className="col-span-12 md:col-span-7 row-span-3"
            />
          )
        }

        if (patternIndex === 1) {
          return (
            <BentoItem
              key={index}
              image={image}
              onClick={() => openLightbox(index)}
              className="col-span-12 md:col-span-5 row-span-3"
            />
          )
        }

        // 3 male
        if (patternIndex === 2) {
          return (
            <BentoItem
              key={index}
              image={image}
              onClick={() => openLightbox(index)}
              className="col-span-12 md:col-span-4 row-span-2"
            />
          )
        }

        if (patternIndex === 3) {
          return (
            <BentoItem
              key={index}
              image={image}
              onClick={() => openLightbox(index)}
              className="col-span-12 md:col-span-5 row-span-2"
            />
          )
        }

        return (
          <BentoItem
            key={index}
            image={image}
            onClick={() => openLightbox(index)}
            className="col-span-12 md:col-span-3 row-span-2"
          />
        )
      })}
    </div>
  )
}